<script setup lang="ts">
  import { trans } from '@bv/utils';

  import CallAction from '../CallAction.vue';

  import MuteIcon from './MuteIcon.vue';
  import UnmuteIcon from './UnmuteIcon.vue';

  defineProps<{
    isMute: boolean;
  }>();
</script>

<template>
  <call-action
    :title="isMute ? trans('voip.calls.call_action.unmute_trans') : trans('voip.calls.call_action.mute_trans')"
  >
    <mute-icon v-if="!isMute" />
    <unmute-icon v-else />
  </call-action>
</template>
